<template>
    <section class="tables new-updated-design">
        <video-popup :videoData="videoData" />
        <vue-snotify></vue-snotify>
        <div class="row">
            <div class="col-lg-12 grid-margin stretch-card">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">View Videos</h4>
                    </div>
                    <div class="card-body">
                        <div class="panel-heading">
                            <div class="row">
                                <div class="col-lg-3 col-md-4 col-sm-6">
                                    <input class="form-control" type="text" name="search" id="search" placeholder="Search"
                                        v-model="serverParams.customFilters.name" @keyup="loadItems()">
                                </div>
                                <div class="col-md-3">
                                </div>
                            </div>
                        </div>
                        <div style="overflow: auto;">
                            <CircleLoader v-if="isLoading" />
                            <table class="table">
                                <thead class=" table-dark">
                                    <tr>
                                        <th scope="col">Video Name</th>
                                        <th scope="col">Description</th>
                                        <th scope="col">Module Name</th>
                                        <th scope="col">Week Name</th>
                                        <th scope="col">Video Links</th>
                                        <th scope="col">Action</th>
                                    </tr>
                                </thead>
                                <tbody v-for="(vid, index) in rows" :key="index">
                                    <tr v-if="shouldShowHeading(vid.ModuleID)">
                                        <th class="text-center" colspan="6">
                                            <h4>Module {{ vid.ModuleID }} - {{ vid.ModuleName }}</h4>
                                        </th>
                                    </tr>
                                    <tr>
                                        <th scope="row">{{ vid.VideoName }}</th>
                                        <td>{{ vid.Description }}</td>
                                        <td>{{ vid.ModuleName }}</td>
                                        <td>{{ vid.WeekName }}</td>
                                        <td>
                                        <a class="videomodal pointer" @click.prevent="showVideo(vid.Link)">
                                            {{ vid.Link ? vid.Link : vid.Videolink }}
                                        </a>
                                    </td>

                                        <td>
                                            <button @click="editVideo(vid)" class="btn btn-sm btn-primary"> Edit </button>
                                            <button @click="deleteVideo(vid.VideoID)" class="btn btn-sm btn-danger">Delete</button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div></div>
    </section>
</template>

<script>
import Vue from "vue";
import SortedTablePlugin from "vue-sorted-table";
import API from '@/api'
import VideoPopup from './components/VideoPopup.vue';

Vue.use(SortedTablePlugin, {
    ascIcon: '<i class="ti-arrow-down"></i>',
    descIcon: '<i class="ti-arrow-up"></i>'
});
export default {
  components: { VideoPopup },
    name: 'VendorName',
    data() {
        return {
            videoData:{
                videoSrc:""
            },
            isDisabled: false,
            selected: true,
            unSelected: false,
            serverParams: {
                customFilters: {
                    name: ''
                },
                sort: [
                    {
                        field: 'VideoID', // example: 'name'
                        type: 'desc' // 'asc' or 'desc'
                    }
                ],

                page: 1, // what page I want to show
                perPage: 10 // how many items I'm showing per page
            },
            columns: [
                {
                    label: 'Video Name',
                    field: 'VideoName',
                    filterable: false,
                },
                {
                    label: 'Description',
                    field: 'Description',
                    sortable: false,
                },
                {
                    label: 'Module Name',
                    field: "ModuleName",
                    sortable: false,
                },
                {
                    label: 'Week Name',
                    field: "WeekName",
                    sortable: false,
                },
                {
                    label: 'Video Links',
                    field: "Videolink",
                    sortable: false,
                },
                {
                    label: 'Action',
                    field: "action",
                    sortable: false,
                },


            ],
            isLoading: false,
            rows: [],
            totalRecords: 0,
            spots: []
        };
    },
    methods: {
        showVideo(src){
            this.videoData.videoSrc ='https://player.vimeo.com/video/' + src;

            this.$bvModal.show('videoModel');
        },
        shouldShowHeading(id) {
            if (id === this.currentModuleID) {
                return false; // Hide the heading if the module ID is the same as the currentModuleID
            } else {
                this.changeCurrentId(id);
                return true; // Show the heading if the module ID is different from the currentModuleID
            }
        },
        changeCurrentId(id) {
            this.currentModuleID = id;
        },
        loadItems() {
            this.isLoading = true;
            API.getAllVideos(this.serverParams,
                data => {
                    this.totalRecords = data.totalRecords;
                    this.rows = data.data;
                    this.isLoading = false;
                }, err => {
                })
        },
        editVideo(member) {
            //  console.log(member);
            this.$router.push({ name: 'edit_video', params: { id: member.VideoID, user: member } });
        },
        deleteVideo(id) {
            this.$swal({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.value) {
                    let data = {
                        id: id
                    }
                    API.deleteVideo(
                        data,
                        data => {
                            this.loadItems();
                            this.$swal(
                                'Deleted!',
                                'Record has been deleted.',
                                'success'
                            )
                        },
                        err => {
                            console.log(err);
                            this.$showNotification({ message: "Failed system error" }, 'error')
                        })
                }
            })
            // this.$router.push({name: 'edit_Vendor', params: {user: member}});
        },

        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
        },
        onPageChange(params) {
            this.updateParams({ page: params.currentPage });
            this.loadItems();
        },
        onPerPageChange(params) {
            this.updateParams({ perPage: params.currentPerPage });
            this.loadItems();
        },
    },
    computed: {}
    ,
    mounted() {
        this.loadItems();
    }
}
</script>